import { isDefined } from '@terros/common'
import { keys, type MantineBreakpoint, useMantineTheme } from '@mantine/core'

export type ContainerCols = { base: number } & Partial<Record<MantineBreakpoint, number>>

/**
 * Resolves named breakpoints for `SimpleGrid type='container'`.
 *
 * Mantine only maps breakpoint names to values for `type='media'`. The container
 * path interpolates the key straight into `@container (min-width: <key>)`, so a
 * name produces an invalid query the browser silently drops. Swapping the names
 * for their theme values lets call sites keep using `{ base: 1, sm: 2 }`.
 */
export const useContainerCols = ({ base, ...named }: ContainerCols): Record<string, number> => {
  const { breakpoints } = useMantineTheme()
  return keys(named).reduce<Record<string, number>>(
    (acc, name) => {
      const cols = named[name]
      if (isDefined(cols)) acc[breakpoints[name]] = cols
      return acc
    },
    { base }
  )
}
